export default __webpack_public_path__ + "static/media/img-03.15751cb4.jpg";